/**
 * Returns true if the ID is for a preview item
 * @param id the id to check
 */
export function isPreviewItemId(id: string): boolean {
    return id ? id.substring(0, 2) == 'p_' : false;
}

/**
 * transforms a given id into a preview item id
 * @returns the new id to use for a preview item
 */
export function makePreviewItemId(): string {
    return 'p_' + Math.ceil(Math.random() * 1000).toString();
}
